export const apiPaths = {
  v1Partner: 'v1/partner/',
  v1Admin: 'v1/admin/',
  v1Auth: 'v1/auth/',
  v1Cause: 'v1/organisations/',
  v1Claims: 'v1/claims',
  v1VSClaims: 'v1/iam/claim',
  v1VSOrganization: 'v1/iam/signup-new-organisation',
  v1Account: 'v1/account/',
  v1Countries: 'v1/countries/',
  v1AgentVerification: 'v1/agent-verifications/',
  v1AgentVerificationUserVerification: 'v1/agent-verification-user-verification',
  v1Currencies: 'v1/currencies',
  v1IamAccounts: '/v1/iam/accounts',
  v1IamAccountsRolesAttach: '/iam/accounts/roles/attach',
  v1IamAccountsInvite: '/v1/iam/invite',
  v1IamPermissions: '/v1/iam/permissions',
  v1IamRoles: '/v1/iam/roles',
  v1StoreApplications: '/v1/store/applications',
  v1StoreSurveys: '/v1/store/surveys',
  v1AccountMarketingConsent: 'v1/account/legal/marketing-consent-for-account',
  v1CauseUsers: 'v1/causes/users',
  v1CPLinkToken: 'v1/cp-link/token',
  v1VolunteeringPartners: 'v1/volunteering/organisations/partners',
  v1VolunteeringPartnerSkills: 'v1/volunteering/organisations/partners/{partnerId}/skills',
  v1VolunteeringPartnerActivities: 'v1/volunteering/organisations/partners/{partnerId}/activities',
  v1VolunteeringPartnerRegions: 'v1/volunteering/organisations/partners/{partnerId}/regions',
  v1VolunteeringOrganisationCreatedOpportunities: 'v1/volunteering/organisations/opportunities',
  v1EditVolunteeringOrganisationCreatedOpportunity: 'v1/volunteering/organisations/opportunities/{opportunityId}',
  v1EditVolunteeringOrganisationCreatedOpportunityLocation:
    'v1/volunteering/organisations/opportunities/{opportunityId}/location',
  v1CancelVolunteeringOpportunity: 'v1/volunteering/organisations/opportunities/{opportunityId}/cancel',
  v1VolunteeringOrganisationCreatedOpportunitiesParticipants:
    'v1/volunteering/organisations/reporting/opportunities/{opportunityId}/participants',
  v1VolunteeringOpportunityDetails: 'v1/volunteering/organisations/opportunities/{id}/details',
  v1ProductOfferClick: 'v1/causes/offer-views'
}

export const baseUrl = 'v1/'
